import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table history movement view.
 */
export default class tableHistoryMovementView extends JetView {
    /**
     * Configures the datatable for displaying history movements.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user ID from parameters

        return {
            view: 'datatable', // Define the view as a datatable
            id: 'datatable', // Set the ID for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Define columns for the datatable
                {
                    id: 'UserId',
                    header: _('ID Usuario'), // Localized header
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'UserName',
                    header: _('Nombre Usuario'), // Localized header
                    width: 250,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 250, sort: 'int' }, // Column for Type
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'), // Localized header
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'Reference',
                    header: _('Referencia'), // Localized header
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'Value',
                    header: _('Valor'), // Localized header
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                },
            ],
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'es/HistoryMovement/GetHistoryMovement?PlayerId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Store the URL for data loading
        var filter = ''; // Initialize filter string
        const cur_user = this.getParam('user', true); // Get current user ID

        // Event listener for filtering data
        this.on(this.app, 'historyMovement:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string for filters

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        // Handle date range for CreatedLocalDate
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else if (object[i][0] == 'ModifiedLocalDate') {
                        // Handle date range for ModifiedLocalDate
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom2=' + date[0];
                        string1 = string1 + '&dateTo2=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else if (typeof object[i][1] === 'object') {
                    // Handle object filters
                    var object2 = Object.entries(object[i][1]);
                    for (var j = 0; j < object2.length; j++) {
                        if (object2[j][1] !== null) {
                            if (object2[j][0] === 'start') {
                                // Handle start date
                                var d = new Date(object2[j][1]);
                                var dateFrom =
                                    'dateFrom=' +
                                    d.getFullYear() +
                                    ':' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + d.getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + d.getHours()).slice(-2) +
                                    ':' +
                                    ('00' + d.getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + d.getSeconds()).slice(-2);
                                string1 = string1 + '&' + dateFrom;
                            } else if (object2[j][0] === 'end') {
                                // Handle end date
                                var d = new Date(object2[j][1]);
                                var dateTo =
                                    'dateTo=' +
                                    d.getFullYear() +
                                    ':' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + d.getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + d.getHours()).slice(-2) +
                                    ':' +
                                    ('00' + d.getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + d.getSeconds()).slice(-2);
                                string1 = string1 + '&' + dateTo;
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to filter
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
